import {
  Button,
  Card,
  CardContent,
  Container,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import config from '../config';
import { useClearState } from '../hooks';

const {
  app: { version },
} = config;

/**
 * Error page.
 * @param {object} props Props accepted by the component.
 * @param {object} props.error Error that was caught by the boundary.
 * @param {object} props.resetErrorBoundary Function to reset the boundary.
 * @returns {import('react').FunctionComponent} React element that contains the page.
 */
function ErrorPage({ error, resetErrorBoundary }) {
  const { palette } = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const clearState = useClearState();

  const onClick = () => {
    // TODO: restore URL
    clearState();
    navigate('/');
    resetErrorBoundary();
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        height: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Card sx={{ width: '100%' }}>
        <CardContent>
          <Stack spacing={3}>
            <Stack
              direction="row"
              sx={{ alignItems: 'center', justifyContent: 'space-between' }}
            >
              <Typography variant="h4" color="primary.main">
                {t('pages.error.title')}
              </Typography>
              <FontAwesomeIcon
                icon="fa-triangle-exclamation"
                size="2x"
                color={palette.primary.main}
              />
            </Stack>
            <Stack spacing={2}>
              <Typography>{t('pages.error.message')}</Typography>
              <Typography>{error?.message}</Typography>
            </Stack>
            <Button
              variant="contained"
              onClick={onClick}
              sx={{ alignSelf: 'center' }}
            >
              {t('pages.error.button')}
            </Button>
            <Typography
              variant="subtitle1"
              color="text.secondary"
              align="right"
            >
              {`digital-twin version: ${version}`}
            </Typography>
          </Stack>
        </CardContent>
      </Card>
    </Container>
  );
}

export default ErrorPage;
